import { DefaultLayout } from "../../components";
import styled from "styled-components";
import { useEffect, useMemo, useState } from "react";
import {
  ExchangeTypeEnum,
  FeatureHeadings,
  IExchangeConfig,
} from "../../services";
import React from "react";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../store";
import { FetchExchangeConfigAction, IApplicationState } from "../../store";
import { BaseTable, Button } from "@sede-enterprise/shell-ds-react-framework";
import { Checkbox } from "@sede-enterprise/shell-ds-react-framework";
import { EditExchangeConfigEntity } from "./EditExchangeConfigEntity";
import AddExchangeConfigEntity from "./AddExchangeConfigEntity";
import { LoadingIndicator } from "../../components/LoadingIndicator/LoadingIndicator";
import { CheckForExchangeConfiguration } from "../../helper/disabled-button";
import { CellInfo } from "../../core/types";
interface IExchangeConfigProps { }

const ButtonStyled = styled(Button)`
  min-height: 25px;
`;

const TableContainer = styled.div`
  height: calc(100vh - 200px);
  margin: 20px;
  width: 98vw;
  overflow: hidden;
`;

const TableStyled = styled(BaseTable)`
  width: 100%;
  flex: 1;
  display: block !important;
  height: 100%;
`;

const AddNewDiv = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: -50px;
  margin-bottom: 10px;
  margin-right: 20px;
`;

const ExchangeConfig: React.FC<IExchangeConfigProps> = () => {
  const dispatch = useAppDispatch();

  const calculateMaxHeight = () => {
    return window.innerHeight - 200;
  };

  const isLoading = useSelector(
    (state: IApplicationState) => state.exchangeconfig.loading
  );
  const exceptionMessage = useSelector(
    (state: IApplicationState) => state.exchangeconfig.exceptionMessage
  );
  const profilePage = useSelector(
    (state: IApplicationState) => state.profile.profile
  );
  const postExchangeConfigSuccess = useSelector(
    (state: IApplicationState) =>
      state.exchangeconfig.isPostExchangeConfigSuccess
  );
  const data = useSelector(
    (state: IApplicationState) => state.exchangeconfig.exchangeConfigs
  );
  const rowData = useMemo(() => data || [], [data]);
  const [alertMessage, setAlertMessage] = useState("");
  const [maxHeight, setMaxHeight] = useState(calculateMaxHeight());

  useEffect(() => {
    dispatch(FetchExchangeConfigAction());
  }, [postExchangeConfigSuccess]);

  useEffect(() => {
    if (exceptionMessage) {
      setAlertMessage(exceptionMessage);
    }
  }, [exceptionMessage]);

  useEffect(() => {
    const handleResize = () => {
      setMaxHeight(calculateMaxHeight());
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const renderCheckbox = (value: any) => {
    return <Checkbox checked={value} disabled={true} />;
  };
  const renderEditButton = (value: any) => {
    return (
      <ButtonStyled
        type="button"
        disabled={CheckForExchangeConfiguration(profilePage)}
        variant="outlined"
        size="xsmall"
        onClick={() => onClickEdit(value)}
      >
        {" "}
        Edit
      </ButtonStyled>
    );
  };

  const renderValue = (value: any) => {
    return <div>{value}</div>;
  };

  const renderExchange = (value: any) => {
    return <div>{convertExchangeIdToName(value)}</div>;
  };

  const exchangeConfigColumns = () => [
    {
      header: "Exchange",
      accessorKey: "exchangeId",
      fixed: "left",
      width: "11%",
      cell: (info: CellInfo) => renderExchange(info.getValue()),
    },
    {
      header: "Corridor Code",
      accessorKey: "corridorCode",
      fixed: "left",
      width: "12%",
      cell: (info: CellInfo) => renderValue(info.getValue()),
    },
    {
      header: "Out Area Eic Code",
      accessorKey: "outAreaEicCode",
      fixed: "left",
      width: "12%",
      cell: (info: CellInfo) => renderValue(info.getValue()),
    },
    {
      header: "In Area Eic Code",
      accessorKey: "inAreaEicCode",
      fixed: "left",
      width: "12%",
      cell: (info: CellInfo) => renderValue(info.getValue()),
    },
    {
      header: "Product Type",
      accessorKey: "productType",
      fixed: "left",
      width: "11%",
      cell: (info: CellInfo) => renderValue(info.getValue()),
    },
    {
      header: "Key",
      accessorKey: "key",
      fixed: "left",
      width: "12%",
      cell: (info: CellInfo) => renderValue(info.getValue()),
    },
    {
      header: "Value",
      accessorKey: "value",
      fixed: "left",
      width: "12%",
      cell: (info: CellInfo) => renderValue(info.getValue()),
    },
    {
      header: "Is Active",
      accessorKey: "isActive",
      fixed: "left",
      width: "9%",
      cell: (info: CellInfo) => renderCheckbox(info.getValue()),
    },
    {
      header: "",
      accessorKey: "id",
      width: "9%",
      cell: (info: CellInfo) => renderEditButton(info.row.original),
    },
  ];

  const convertExchangeIdToName = (exchangeId: string) => {
    return exchangeId.toString() === "1"
      ? ExchangeTypeEnum.Jao
      : ExchangeTypeEnum.Empire;
  };

  const [showModal, setShowModal] = useState<boolean>(false);
  const [showAddNewModal, setShowAddNewModal] = useState<boolean>(false);
  const [selectedExchangeConfig, setSelectedExchangeConfig] =
    useState<IExchangeConfig | null>(null);
  const onClickEdit = (exchangeConfig: IExchangeConfig) => {
    setSelectedExchangeConfig(exchangeConfig);
    setShowModal(true);
  };
  const onClickAddNew = () => {
    setShowAddNewModal(true);
  };

  useEffect(() => {
    if (postExchangeConfigSuccess) {
      dispatch(FetchExchangeConfigAction());
    }
  }, [postExchangeConfigSuccess]);

  return (
    <div data-testid="ExchangeConfig">
      <DefaultLayout
        title={FeatureHeadings.ExchangeConfig}
        message={alertMessage}
        children={
          isLoading ? (
            <LoadingIndicator />
          ) : (
            <>
              <AddNewDiv>
                <Button
                  type="button"
                  size="small"
                  disabled={CheckForExchangeConfiguration(profilePage)}
                  onClick={() => onClickAddNew()}
                >
                  Add New
                </Button>
              </AddNewDiv>

              <TableContainer>
                <TableStyled
                  data-testid="ExchangeConfigTable"
                  data={rowData}
                  columns={exchangeConfigColumns()}
                  size="small"
                  stickyHeader={true}
                  maxHeight={maxHeight}
                />
              </TableContainer>

              {showModal && selectedExchangeConfig && (
                <EditExchangeConfigEntity
                  exchangeConfig={selectedExchangeConfig}
                  onCancel={() => {
                    setShowModal(false);
                  }}
                />
              )}
              {showAddNewModal && (
                <AddExchangeConfigEntity
                  onCancel={() => {
                    setShowAddNewModal(false);
                  }}
                />
              )}
            </>
          )
        }
      />
    </div>
  );
};

export default ExchangeConfig;
